import { useEffect, useState } from "react";
import { api } from "../lib/api";

export function useCategories() {
  const [categories, setCategories] = useState([]);
  const refresh = async () => {
    try {
      const r = await api.listCategories();
      setCategories(Array.isArray(r.data) ? r.data : []);
    } catch {
      setCategories([]);
    }
  };
  useEffect(() => { refresh(); }, []);
  return { categories, refresh };
}

export function useServices() {
  const [services, setServices] = useState([]);
  const refresh = async () => {
    try {
      const r = await api.listServices();
      setServices(Array.isArray(r.data) ? r.data : []);
    } catch {
      setServices([]);
    }
  };
  useEffect(() => { refresh(); }, []);
  return { services, refresh };
}
